import Card from './card'
import CardHeader from './card-header'
import CardBody from './card-body'
import CardFooter from './card-footer'
Card.Header = CardHeader
Card.Body = CardBody
Card.Footer = CardFooter
export default Card



// WEBPACK FOOTER //
// ./src/components/card/index.js